import React from 'react'
import SliderDepartments from '../../component/slidercomponent/SliderDepartments'

const DepartmentsHome = () => {
    return (
        <>

            <section className="content-inner bg-light overflow-hidden">
                <div className="container">
                    <div className="section-head style-1 row align-items-center mb-0">
                        <div className="col-sm-12 m-b30 wow fadeInUp" data-wow-delay="0.2s" data-wow-duration="0.8s" style={{ visibility: 'visible', animationDuration: '0.8s', animationDelay: '0.2s', animationName: 'fadeInUp' }}>
                            <h2 className="title" style={{ textAlign: "center" }}>हमारे विशेषज्ञता वाले विभाग </h2>
                        </div>
                    </div>
                    <SliderDepartments />

                </div>

            </section>

        </>
    )
}

export default DepartmentsHome